module.exports = __webpack_public_path__ + "static/media/toClose.82aa45c0.svg";